'use client'

import React from 'react'
import { Loader2 } from 'lucide-react'
import { homeV2Text, homeV2Type } from '@/lib/home/homeV2Theme'

export type PlayExperienceLoadingStateProps = {
  /** Optional diagnostic attrs from PlayTabExperience. */
  diagnosticProps?: Record<string, string | undefined>
}

/**
 * Shared Play loading presentation for every distribution channel that mounts
 * PlayTabExperience / PlayIntegratedExperience (native, PWA, mobile web, desktop).
 * Presentation only — does not own fetch/transport.
 */
export function PlayExperienceLoadingState({
  diagnosticProps,
}: PlayExperienceLoadingStateProps) {
  return (
    <div
      className="box-border flex min-h-[max(16rem,100%)] w-full flex-1 flex-col items-center justify-center px-6 py-10"
      data-play-tab-shell="integrated"
      data-play-tab-ui="loading"
      data-play-experience-loading="true"
      {...diagnosticProps}
    >
      <div
        role="status"
        aria-live="polite"
        aria-label="Loading Play experience"
        className="flex flex-col items-center text-center"
      >
        <Loader2
          className="mb-3 h-6 w-6 animate-spin text-white/85"
          aria-hidden
        />
        <p
          className="text-sm font-medium text-white"
          style={homeV2Type(homeV2Text.body)}
        >
          Loading Play experience...
        </p>
        <p
          className="mt-1.5 text-xs text-white/70"
          style={homeV2Type(homeV2Text.muted)}
        >
          Fetching your dog&apos;s world
        </p>
      </div>
    </div>
  )
}
